<template>
  <div id="iss">
    <p style="text-align: center !important; font-size: 23px; color: #808080">
      selecione a capital
    </p>
    <div class="selecione">
      <div :class="`drop ${drop2}`" @click="aparecer()">
        <span style="margin-left: 10px; color: #b3b3b3">{{ ti }}</span>
        <span v-if="v1" id="triangulo-para-baixo"></span>
        <span v-else id="triangulo-para-cima"></span>
      </div>
      <div class="capital" v-show="v1">
        <ul>
          <li @click="seleciona(1, 'Aracaju/SE')">Aracaju/SE</li>
          <li @click="seleciona(2, 'Belém/PA')">Belém/PA</li>
          <li @click="seleciona(3, 'Belo Horizonte/MG')">Belo Horizonte/MG</li>
          <li @click="seleciona(4, 'Boa Vista/RR')">Boa Vista/RR</li>
          <li @click="seleciona(5, 'Brasília/DF')">Brasília/DF</li>
          <li @click="seleciona(6, 'Campo Grande/MS')">Campo Grande/MS</li>
          <li @click="seleciona(7, 'Cuiabá/MT')">Cuiabá/MT</li>
          <li @click="seleciona(8, 'Curitiba/PR')">Curitiba/PR</li>
          <li @click="seleciona(9, 'Florianópolis/SC')">Florianópolis/SC</li>
          <li @click="seleciona(10, 'Fortaleza/CE')">Fortaleza/CE</li>
          <li @click="seleciona(11, 'Goiânia/GO')">Goiânia/GO</li>
          <li @click="seleciona(12, 'João Pessoa/PB')">João Pessoa/PB</li>
          <li @click="seleciona(13, 'Macapá/AP')">Macapá/AP</li>
          <li @click="seleciona(14, 'Maceió/AL')">Maceió/AL</li>
          <li @click="seleciona(15, 'Manaus/AM')">Manaus/AM</li>
          <li @click="seleciona(16, 'Natal/RN')">Natal/RN</li>
          <li @click="seleciona(17, 'Palmas/TO')">Palmas/TO</li>
          <li @click="seleciona(18, 'Porto Alegre/RS')">Porto Alegre/RS</li>
          <li @click="seleciona(19, 'Porto Velho/RO')">Porto Velho/RO</li>
          <li @click="seleciona(20, 'Recife/PE')">Recife/PE</li>
          <li @click="seleciona(21, 'Rio Branco/AC')">Rio Branco/AC</li>
          <li @click="seleciona(22, 'Rio de Janeiro/RJ')">Rio de Janeiro/RJ</li>
          <li @click="seleciona(23, 'Salvador/BA')">Salvador/BA</li>
          <li @click="seleciona(24, 'São Luis/MA')">São Luis/MA</li>
          <li @click="seleciona(25, 'São Paulo/SP')">São Paulo/SP</li>
          <li @click="seleciona(26, 'Teresina/PI')">Teresina/PI</li>
          <li @click="seleciona(27, 'Vitória/ES')">Vitória/ES</li>
        </ul>
      </div>
    </div>
    <br />
    <br />
    <div style="border-bottom: 1px solid #a09e9e; padding: 0px">
      <p
        style="
          margin-left: 7px;
          font-style: italic;
          font-size: 20px;
          font-weight: bold;
          color: rgb(128, 128, 128);
          margin-bottom: 0.6px;
        "
      >
        {{ titulo }}
      </p>
    </div>
    <div v-if="!spinner2" style="min-height: 550px">
      <div v-if="ISS.length >= 1">
        <div v-for="(n, i) in ISS" :key="i" class="is">
          <div style="display: flex; align-items: center">
            <img src="/sandboxfront/rtfonte/engrenagem.svg" alt="" />
            <span class="ti" style="font-size: 20px">
              Dados gerais e alíquotas</span
            ><br />
          </div>

          <span class="ti">Alíquota:</span><span> {{ n.aliquota }}</span
          ><br />
          <span class="ti">Local do imposto devido Fato gerador do ISSQN:</span
          ><br />

          <span v-html="n.local"></span><br /><br />
          <span class="ti">Código de Recolhimento:</span
          ><span> {{ n.codigo_recolhimento }}</span
          ><br />
          <br />
          <div style="display: flex; align-items: center">
            <img src="/sandboxfront/rtfonte/calendario.svg" alt="" />
            <span class="ti" style="font-size: 20px">Vencimentos</span><br />
          </div>

          <span class="ti">Vencimento:</span><span v-html="n.vencimentos"></span
          ><br />
          <br />
          <div class="borda"></div>
          <br />
          <div style="display: flex; align-items: center">
            <img src="/sandboxfront/rtfonte/file.svg" alt="" /><span
              class="ti"
              style="font-size: 20px"
              >Dados complementares</span
            ><br />
          </div>

          <div
            v-html="n.observacoes"
            style="margin-top: 10px; color: #707070"
          ></div>
          <div v-html="n.texto" style="margin-top: 10px; color: #707070"></div>
        </div>
        <hr />
      </div>
    </div>
    <div v-else>
      <span class="skeleton-loaderOutrasPagMenor"></span>
      <span class="skeleton-loaderOutrasPagMenor"></span>
      <span class="skeleton-loaderOutrasPagMenor"></span>
      <span class="skeleton-loaderOutrasPagMaior"></span>
      <hr />
      <span class="skeleton-loaderOutrasPagMenor"></span>
      <span class="skeleton-loaderOutrasPagMaior"></span>
      <span class="skeleton-loaderOutrasPagMaior"></span>
    </div>
    <div style="display: flex; justify-content: center" v-if="v">
      <div>
        <button @click="$router.push({ name: 'rtfonte' })" class="voltar">
          voltar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import calculo from "../services/calculo.js";
export default {
  data() {
    return {
      ISS: [],
      spinner: false,
      titulo: "",
      erro: "",
      spinner2: false,
      apar: false,
      drop2: "",
      v: false,
      v1: false,
      ti: "selecione",
    };
  },
  methods: {
    async seleciona(id, titulo) {
      this.v1 = false;
      this.ti = titulo;
      if (this.drop2 == "drop2") {
        this.drop2 = "";
      } else {
        this.drop2 = "drop2";
      }
      this.spinner2 = true;
      this.titulo = titulo;
      this.ISS = await calculo.getGeraISSIgualSite(
        id,
        this.$store.state.idItem
      );
      if (this.ISS.length == 0) {
        this.erro = "Não há previsão legal para retenção.";
      }
      this.spinner2 = false;
      this.v = true;
    },
    aparecer() {
      this.apar = !this.apar;
      this.v1 = !this.v1;
      if (this.drop2 == "drop2") {
        this.drop2 = "";
      } else {
        this.drop2 = "drop2";
      }
    },
  },
};
</script>

<style>
.selecione {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 250px;
  margin: 0 auto;
}
.capital ul li {
  list-style: none;
  line-height: 40px;
  cursor: pointer;
  color: #808080;
  padding-left: 10px;
  position: relative;
  z-index: 2;
}
.capital ul li:hover {
  background: #cfcbcb;
  color: #fff;
  z-index: 2;
}
.capital ul {
  padding: 10px 0px;
  position: relative;
  z-index: 2;
  background: #fff;
  height: 400px;
}
.capital {
  position: absolute;
  top: 34px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-bottom: 2px solid #94618e;
  border-left: 2px solid #94618e;
  border-right: 2px solid #94618e;
  width: 250px;
  height: 400px;
  overflow: scroll;
  z-index: 2;
  overflow-x: hidden;
  background: #fff;
}

.drop {
  cursor: pointer;
  width: 250px;
  height: 45px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 2px solid #94618e;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 3;
}
.drop2 {
  border-top: 2px solid #94618e;
  border-left: 2px solid #94618e;
  border-bottom: none;
  border-right: 2px solid #94618e;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.is {
  position: relative;
  top: 10px;
}
.drop span {
  margin-right: 10px;
}

.is span {
  color: #707070;
}
.ti {
  font-weight: bold;
  color: #707070;
  margin-left: 5px;
}
b,
strong {
  font-weight: bold;
  color: #707070;
}
span p {
  margin-top: 0;
  margin-bottom: 1rem;
  color: #707070;
}
#triangulo-para-cima {
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 15px solid #94618e;
}
#triangulo-para-baixo {
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-top: 15px solid #94618e;
}
.borda {
  border: 0.5px solid rgb(128, 128, 128);
  width: 103%;
  left: -8px;
  position: absolute;
}
.iss {
  position: relative;
}
.iss span {
  margin-right: 20px;
  color: #707070;
}
.ti {
  font-weight: bold;
  color: #707070;
}
b,
strong {
  font-weight: bold;
  color: #707070;
}
</style>
